import api from './api';

export async function getTrips({
  page = 1,
  limit = 20,
  filter,
  search,
} = {}) {
  const params = { page, limit };
  if (filter) params.filter = filter;
  if (search) params.search = search;
  const response = await api.get('/admin/trips', { params });
  return response.data;
}

export async function getTripById(tripId) {
  const response = await api.get(`/admin/trips/${tripId}`);
  return response.data;
}

export async function reviewTrip(tripId, { action, reason } = {}) {
  const payload = { action };
  if (reason) payload.reason = reason;
  const response = await api.patch(`/admin/trips/${tripId}/review`, payload);
  return response.data;
}
